import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormGroup, Validators, } from '@angular/forms';
import { Subject } from 'rxjs';
import { CodeConversionMstDto } from 'sg-api';

@Component({
  selector: 'app-sgke150d-condition',
  templateUrl: './sgke150d-condition.component.html',
  styleUrl: './sgke150d-condition.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgke150dConditionComponent implements OnInit, OnDestroy {

  /** コード変換マスタマップ */
  @Input() codeMap: Map<string, CodeConversionMstDto[]> = null;

  /** 会社コード */
  static S900021: string = 'S900021';

  /** 入金地区コード */
  static S300561: string = 'S300561';

  /** コンポーネント破棄処理*/
  private onDestroy$ = new Subject();
  /** 親フォームグループ情報 */
  private parentForm: UntypedFormGroup;

  /** 出力条件情報FormGroup */
  outputConditionForm: UntypedFormGroup;

  /**
   * コンストラクタ
   * @param {FormGroupDirective} parent
   * @param {UntypedFormBuilder} fb
   * @memberof Sgke150dConditionComponent
   */
  constructor(
    private parent: FormGroupDirective,
    private fb: UntypedFormBuilder,
  ) { }

  /**
   * 初期処理
   * @returns {void}
   * @memberof Sgke150dConditionComponent
   */
  ngOnInit(): void {

    // 親フォームグループ取得
    this.parentForm = this.parent.form;

    // フォームグループの設定
    this.outputConditionForm = this.fb.group({
      // 会社コード
      companycode: { value: this.codeMap.get(Sgke150dConditionComponent.S900021)[0]?.userCode, disabled: true },
      // 入金担当地区コード
      rcvmnyTantoAreacode: { value: this.codeMap.get(Sgke150dConditionComponent.S300561)[0]?.userCode, disabled: true },
      // 報告年月日
      reportYearmonthdate: [{ value: null }, Validators.required],
    });

    this.parentForm.addControl("reqBusinessArea", this.outputConditionForm);

  }

  /**
   * 購読解除
   * @returns {void}
   * @memberof Sgke150dConditionComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('reqBusinessArea');
  }

}
